
import { makeStyles } from 'tss-react/mui';

export const useSaasCardStyles = makeStyles()(
  ({ palette: { primary, divider }, shadows, spacing }) => ({
    saasCard: {
      cursor: 'pointer',
      '&:hover': {
        boxShadow: shadows[6],
      },
    },
    saasCardLogo: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: spacing(),
      paddingBottom: spacing(2),
      borderBottom: `1px solid ${divider}`,
    },
    saasCardContent: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
    },
    saasTitle: {
      fontSize: '1.25rem',
      textAlign: 'center',
      paddingBottom: spacing(0),
      paddingTop: spacing(0.5),
      '& a': {
        color: primary.main,
        textDecoration: 'none',
      },
    },
  })
);
